import { useFeatureVariation } from 'plugins/optimizely/hooks/use-feature-variation';
import { IMMEDIATE_FEATURES, FEATURE_VARIATIONS } from 'utils/experiment';
export const useAirportPriceExperiment = () => {
    const variation = useFeatureVariation(IMMEDIATE_FEATURES.AIRPORT_TOTAL_PRICE_TEST_V2);
    const airportExperimentVariation = FEATURE_VARIATIONS[IMMEDIATE_FEATURES.AIRPORT_TOTAL_PRICE_TEST_V2];
    const hideTotalToggleVariant2 = variation ===
        airportExperimentVariation.SHOW_TOTAL_PRICE_AND_DAILY_PRICE_NO_TOGGLE;
    const hideTotalToggle = variation === airportExperimentVariation.SHOW_TOTAL_PRICE_NO_TOGGLE;
    return {
        hideTotalToggle,
        hideTotalToggleVariant2,
    };
};
